import { render, staticRenderFns } from "./ItemsTable.vue?vue&type=template&id=3ac67bfa&scoped=true&"
import script from "./ItemsTable.vue?vue&type=script&lang=ts&"
export * from "./ItemsTable.vue?vue&type=script&lang=ts&"
import style0 from "./ItemsTable.vue?vue&type=style&index=0&id=3ac67bfa&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3ac67bfa",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VDataTable } from 'vuetify/lib/components/VDataTable';
import { VExpandXTransition } from 'vuetify/lib/components/transitions';
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VBtn,VDataTable,VExpandXTransition,VIcon})
